import useReveal from '../../hooks/useReveal.js';
import Eyebrow from '../ui/Eyebrow.jsx';
import FAQItem from '../primitives/FAQItem.jsx';
import { faqHead, faqItems } from '../../content/faq.js';

/**
 * FAQ — two-column intro + accordion list.
 */
export default function FAQ() {
  const introRef = useReveal();
  const listRef = useReveal();

  return (
    <section id="faq" className="section-pad bg-surface text-ink-50 border-t border-white/[.06]">
      <div className="container-page">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-14 items-start">
          <div ref={introRef} className="reveal">
            <Eyebrow>{faqHead.eyebrow}</Eyebrow>
            <h2 className="mt-4 text-display-md tracking-[-0.03em] text-ink-50">{faqHead.heading}</h2>
            <p className="mt-4 text-ink-200">
              {faqHead.lead}{' '}
              <a
                href={faqHead.leadLink.href}
                className="text-brand-blue-bright font-semibold hover:underline"
              >
                {faqHead.leadLink.label}
              </a>{' '}
              {faqHead.leadTrail}
            </p>
          </div>

          <div ref={listRef} className="reveal">
            {faqItems.map((item) => (
              <FAQItem key={item.q} {...item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
